import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { ContestStatusModule } from '@freelancer/contest-status';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { EntryUpdateErrorComponent } from './contest-entries-tab/entry-update-error/entry-update-error.component';
import { ContestViewChallengeElementNavigationCardComponent } from './contest-view-header/enterprise-header/contest-view-challenge-element-navigation/contest-view-challenge-element-navigation-card.component';
import { ContestViewChallengeElementNavigationComponent } from './contest-view-header/enterprise-header/contest-view-challenge-element-navigation/contest-view-challenge-element-navigation.component';
import { ContestViewHeroBannerChallengeComponent } from './contest-view-header/enterprise-header/contest-view-hero-banner-challenge/contest-view-hero-banner-challenge.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    ContestStatusModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [
    ContestViewChallengeElementNavigationCardComponent,
    ContestViewChallengeElementNavigationComponent,
    ContestViewHeroBannerChallengeComponent,
    EntryUpdateErrorComponent,
  ],
  exports: [
    ContestViewChallengeElementNavigationCardComponent,
    ContestViewChallengeElementNavigationComponent,
    ContestViewHeroBannerChallengeComponent,
    EntryUpdateErrorComponent,
  ],
})
export class ContestViewSharedModule {}
